import request from "@/router/axios";
export const getChangeReserve = (scheduleDate, resourceId) => {
  return request({
    url: `/api/jy/bill/getChangeReserve`,
    method: "get",
    params: {
      scheduleDate: scheduleDate,
      resourceId: resourceId,
    },
  });
};
